export const defaultSettings = Object.freeze({
  companyName: "Speedy Freight"
});

export const commentTypeId = Object.freeze({
  supplierStatement: 1,
  job: 2,
  account: 3,
  default: 0
});

export const commentTypeDescription = Object.freeze({
  [commentTypeId.supplierStatement]: {
    text: "Supplier Statement",
    iconText: "fa-calendar-alt"
  },
  [commentTypeId.job]: { text: "Job", iconText: "fa-chalkboard" },
  [commentTypeId.account]: { text: "Account", iconText: "fa-user" },
  [commentTypeId.default]: { text: "Default", iconText: "fa-comment" }
});

export const defaultBillingData = Object.freeze({
  invoiceTypeId: 9,
  invoiceScheduleId: 1,
  paymentTermId: 1,
  factoringDdTypeId: 1
});

export const fractionDigits = Object.freeze({
  minimum: 2,
  maximum: 2
});

export const defaultGoodsData = Object.freeze({
  quantity: 1,
  description: "Goods",
  weight: 50,
  length: 0,
  height: 0,
  width: 0,
  consolidatedSwitch: false
});

export const contactTypeId = Object.freeze({
  PRIMARY: 1,
  SECONDARY: 2,
  BILLING: 3,
  OTHER: 4,
  SUPPLIER: 6,
  COLLECTION: 7,
  DELIVERY: 8,
  ACCOUNTS_PAYABLE: 9,
  STATEMENT: 10
});

export const accountTypeId = Object.freeze({
  CASH: 1,
  CREDIT: 2
});

export const paymentTypeId = Object.freeze({
  PORTAL: 1,
  CHEQUE: 2,
  BACS: 3,
  STRIPE_LINK: 4,
  DIRECT_DEBIT: 5
});

export const stripePaymentStatusId = Object.freeze({
  SENT: { id: 189, text: "Sent" },
  PENDING: { id: 190, text: "Pending" },
  PAID: { id: 191, text: "Paid" },
  UNPAID: { id: 192, text: "Unpaid" }
});

export const extendedJobRequirementTypes = Object.freeze({
  HIAB: { id: 1, text: "Hiab", iconText: "fa-truck-tow", activeInd: 1 },
  TWO_MAN: {
    id: 2,
    text: "Two Man",
    iconText: "fa-people-pants-simple",
    activeInd: 1
  },
  MOFFET_MOUNTY: {
    id: 3,
    text: "Moffet Mounty",
    iconText: "fa-forklift",
    activeInd: 1
  },
  WAIT_AND_RETURN: {
    id: 4,
    text: "Wait and Return",
    iconText: "fa-rotate-left",
    activeInd: 1
  },
  LIFT_GATE: { id: 5, text: "Lift Gate", iconText: "fa-circle", activeInd: 0 },
  TAIL_LIFT: {
    id: 6,
    text: "Tail Lift",
    iconText: "fa-cart-flatbed-empty",
    activeInd: 1
  },
  TRAILER: { id: 7, text: "Trailer", iconText: "fa-trailer", activeInd: 1 }
});

export const deletedId = Object.freeze({
  DELETED: 21
});

export const isPreferredIndId = Object.freeze({
  IS_PREFERRED: 1,
  IS_NOT_PREFERRED: 0
});

export const indicatorStatusId = Object.freeze({
  YES: 1,
  NO: 0
});

export const addressTypeId = Object.freeze({
  PRIMARY: 1,
  BILLING: 2,
  COLLECTION: 3,
  DELIVERY: 4,
  SECONDARY: 5,
  TRADING: 6,
  REGISTERED_OFFICE: 7,
  BOOKER: 8,
  STATEMENT: 9
});

export const nationalCustomerIndId = Object.freeze({
  YES: 1,
  NO: 0,
  BOTH: 2
});

export const glCodeId = Object.freeze({
  CORE_ACCOUNT: {
    ID: 1,
    CODE: 40000,
    TYPE: "CUSTOMER"
  },
  NATIONAL_ACCOUNT: {
    ID: 2,
    CODE: 40010,
    TYPE: "CUSTOMER"
  },
  DRIVER_COST: {
    ID: 3,
    CODE: 60020,
    TYPE: "SUPPLIER"
  },
  PURCHASE: {
    ID: 7,
    CODE: 53062,
    TYPE: "SUPPLIER"
  },
  REVENUE: {
    ID: 8,
    CODE: 40008,
    TYPE: "CUSTOMER"
  }
});

export const notificationStatusId = Object.freeze({
  UNREAD: 78,
  READ: 79,
  DELETED: 80
});

export const notificationStatusTypeId = Object.freeze({
  COMMENT: 1,
  EXCEL: 2
});

export const supplierStatusId = Object.freeze({
  AVAILABLE: 70,
  REQUESTED: 71,
  REJECTED: 72,
  EXPIRING: 73,
  EXPIRED: 74,
  IN_PROGRESS: 76,
  INACTIVE: 77
});

export const accountStatusId = Object.freeze({
  ACTIVE: 10,
  DORMANT: 11,
  ON_HOLD: 12,
  PREMIUM: 13,
  MONITORED: 14,
  QUOTE: 15,
  LOST: 208,
  CLOSED: 17,
  PENDING: 176,
  NEW: 177,
  FLIPPED: 178,
  ARCHIVED: 210
});

export const accountClassificationId = Object.freeze({
  PRIVATE: 1,
  LTD: 2,
  SOLE_TRADER: 3,
  LLP: 4,
  "S-CORP": 5,
  "C-CORP": 6,
  LLC: 7
});

export const businessAreaTypeId = Object.freeze({
  DEFAULT: 1
});

export const cardPaymentIndId = Object.freeze({
  YES: 1,
  NO: 0
});

export const manualCostIndId = Object.freeze({
  YES: 1,
  NO: 0
});

export const currencyTypeId = Object.freeze({
  POUND: 1,
  DOLLAR: 2,
  EURO: 3
});

export const taxRateType = Object.freeze({
  YES: {
    id: 1,
    description: "Yes"
  },
  NO: {
    id: 0,
    description: "No"
  }
});

export const taxRateTypeId = Object.freeze({
  VAT_20: 1,
  VAT_0: 2,
  VAT_5: 3,
  VAT_10: 4,
  VAT_15: 5,
  VAT_25: 6,
  VAT_21: 7
});

export const countryTypeId = Object.freeze({
  SPAIN: 9,
  GB: 12,
  US: 231,
  CA: 67,
  PO: 21
});

export const countryCodeTypeId = Object.freeze({
  [countryTypeId.GB]: "GB",
  [countryTypeId.SPAIN]: "ES",
  [countryTypeId.US]: "US",
  [countryTypeId.CA]: "CA",
  [countryTypeId.PO]: "PO"
});

export const intlDialingCodes = Object.freeze({
  [countryTypeId.GB]: 44,
  [countryTypeId.SPAIN]: 34,
  [countryTypeId.US]: 1,
  [countryTypeId.CA]: 1,
  [countryTypeId.PO]: 48
});

export const intlDialingCodeTypeId = Object.freeze({
  [countryTypeId.GB]: 225,
  [countryTypeId.SPAIN]: 199,
  [countryTypeId.US]: 226,
  [countryTypeId.CA]: 36,
  [countryTypeId.PO]: 167
});

export const jobDeliveryStatusTypeId = Object.freeze({
  ACTIVE: 34,
  INACTIVE: 35
});

export const jobStatusTypeId = Object.freeze({
  UNALLOCATED: 39,
  COMPLETED: 40,
  CANCELLED: 41,
  ARRIVED_FOR_COLLECTION: 42,
  GOODS_COLLECTED: 43,
  ARRIVED_FOR_DELIVERY: 44,
  GOODS_DELIVERED: 45,
  POD_RECEIVED: 46,
  INVOICED: 47,
  SUPPLIER_DISPUTE: 49,
  QUOTE_LOST: 51,
  PRE_PENDING_QUOTE: 52,
  PENDING_QUOTE: 53,
  TRANSPORT_REVIEW: 54,
  ALLOCATED: 55,
  PENDING_JOB: 56,
  PO_REQUIRED: 57,
  ON_ROUTE_TO_COLLECTION: 59,
  ON_ROUTE_TO_DELIVERY: 60,
  READY_TO_INVOICE: 61,
  IN_DISPUTE_INVOICE: 62,
  INVOICE_IN_PROGRESS: 63,
  IN_DISPUTE: 65,
  RUNNING_LATE: 66,
  QUOTE_REQUESTED: 175,
  QUOTE_EXPIRED: 184,
  CUSTOMER_DISPUTE: 48,
  JOB_DISPUTE: 64,
  POD_REQUIRED: 195
});

export const iconStatusTypes = Object.freeze({
  jobUnknownStatusTypes: {
    QUOTE_WON: 36,
    JOB_CONFIRMED: 37,
    ALLOCATED: 38,
    JOB_BOOKING_ACTIVE: 50,
    QUOTE_ONLY_JOB: 58
  },
  jobStatusTypes: {
    ...jobStatusTypeId
  },
  jobDeliveryStatusTypes: {
    ...jobDeliveryStatusTypeId
  }
});

export const reviewStatusTypeId = Object.freeze({
  IN_REVIEW: {
    id: 193,
    text: "In Review"
  },
  REVIEWED: {
    id: 194,
    text: "Reviewed"
  }
});

export const invoiceTypeId = Object.freeze({
  MONTHLY: 2,
  ARGOS: 3,
  SUB_PO_INVOICING: 4,
  PRE_ADVICE: 8,
  ON_DAY: 9,
  SPAIN: 10,
  PURCHASE_ORDER: 11
});

export const skeletonClosetId = Object.freeze({
  QTY: 2
});

export const billingStoreId = Object.freeze({
  PARENT: 1,
  SAME_AS_ACCOUNT: 2,
  OTHER: 3
});

export const invoiceStatus = Object.freeze({
  CREATED: {
    ID: 82,
    COLOUR: "green",
    TEXT: "Created"
  },
  SENT: {
    ID: 83,
    COLOUR: "green",
    TEXT: "Sent"
  },
  INVOICE_DISPUTE: {
    ID: 84,
    COLOUR: "red",
    TEXT: "Invoice Dispute"
  },
  DISPUTE_RESOLVED: {
    ID: 85,
    COLOUR: "green",
    TEXT: "Dispute Resolved"
  },
  AWAITING_APPROVAL: {
    ID: 86,
    COLOUR: "locked",
    TEXT: "Awaiting Approval"
  },
  NOT_YET_DUE: {
    ID: 180,
    COLOUR: "blue",
    TEXT: "Not Yet Due"
  },
  PARTIALLY_PAID: {
    ID: 181,
    COLOUR: "yellow",
    TEXT: "Partially Paid"
  },
  OVERDUE: {
    ID: 182,
    COLOUR: "locked",
    TEXT: "Overdue"
  },
  PAID: {
    ID: 183,
    COLOUR: "green",
    TEXT: "Paid"
  }
});

export const financialInvoiceStatus = Object.freeze({
  CREATED: {
    ID: 196,
    COLOUR: "green",
    TEXT: "Created"
  },
  SENT: {
    ID: 197,
    COLOUR: "green",
    TEXT: "Sent"
  },
  PAID: {
    ID: 186,
    COLOUR: "green",
    TEXT: "Paid"
  }
});

export const financialCreditNoteStatus = Object.freeze({
  CREATED: {
    ID: 198,
    COLOUR: "green",
    TEXT: "Created"
  },
  SENT: {
    ID: 199,
    COLOUR: "green",
    TEXT: "Sent"
  },
  PAID: {
    ID: 186,
    COLOUR: "green",
    TEXT: "Paid"
  }
});

export const derivedIncomeInvoiceStatus = Object.freeze({
  CREATED: {
    ID: 212,
    COLOUR: "green",
    TEXT: "Created"
  },
  SENT: {
    ID: 213,
    COLOUR: "green",
    TEXT: "Sent"
  }
});

export const unitOfMeasureTypeId = Object.freeze({
  DISTANCE: 1,
  WEIGHT: 2,
  DIMENSION: 3,
  VOLUME: 4
});

export const unitOfMeasureId = Object.freeze({
  DISTANCE: {
    MILES: 1,
    KILOMETRES: 2
  },
  WEIGHT: {
    KILOGRAMS: 3,
    POUNDS: 4
  },
  DIMENSION: {
    CENTIMETRES: 5,
    INCHES: 6
  },
  VOLUME: {
    CUBIC_METRES: 7,
    CUBIC_YARDS: 8
  }
});

export const defaultUnitOfMeasure = Object.freeze({
  MILES: {
    uomShortHand: "mi",
    uomDescription: "Miles"
  },
  KILOGRAMS: {
    uomShortHand: "kg",
    uomDescription: "Kilograms"
  },
  CENTIMETRES: {
    uomShortHand: "cm",
    uomDescription: "Centimetres"
  },
  CUBIC_METRES: {
    uomShortHand: "m³",
    uomDescription: "Cubic Metres"
  }
});

export const usUnitOfMeasure = Object.freeze({
  KILOMETRES: {
    uomShortHand: "km",
    uomDescription: "Kilometres"
  },
  POUNDS: {
    uomShortHand: "lb",
    uomDescription: "Pounds"
  },
  INCHES: {
    uomShortHand: "in",
    uomDescription: "Inches"
  },
  CUBIC_YARDS: {
    uomShortHand: "yd³",
    uomDescription: "Cubic Yards"
  }
});

export const totalUomFieldTypes = Object.freeze({
  TOTAL_MILEAGE: "TOTAL_MILEAGE",
  TOTAL_KM: "TOTAL_KM"
});

export const timeOptionId = Object.freeze({
  fixedTime: 1,
  asap: 2,
  am: 3,
  pm: 4,
  timeRange: 5,
  allDay: 6,
  dateRange: 7
});

export const DBBoolean = Object.freeze({
  TRUE: 1,
  FALSE: 0
});

export const statementStatuses = Object.freeze({
  OUTSTANDING: 132,
  INVOICE_DISCREPANCY: 133,
  POD_DISCREPANCY: 134,
  ADDITIONS: 135,
  SPECIAL_PAYMENT: 136,
  SAME_DAY_PAYMENT: 137,
  UPDATED: 138,
  MOVED_TO_MONTHLY: 139,
  FULL_PAYMENT_DUE: 140,
  PART_PAYMENT_DUE: 141,
  DRIVER_PART_PAID: 142,
  DRIVER_PAID: 143,
  STATEMENT_GENERATED: 144,
  PENDING_AUTHORISATION: 145
});

export const supplierInvoiceStatuses = Object.freeze({
  IN_DISPUTE: 187
});

export const supplierInvoiceTypes = Object.freeze({
  STATEMENT: 1,
  OVERHEAD: 2
});

export const SupplierTypes = Object.freeze({
  CX: 1,
  NON_CX: 2,
  FRANCHISEE: 3,
  DRIVERS_WEEKLY: 4,
  DRIVERS_MONTHLY: 5,
  EMPLOYEE: 6,
  T24: 7
});

export const errorMessages = Object.freeze({
  PRIMARY_ADDRESS:
    "A Primary Address must exist. Please save a primary address before adding an alternative address type.",
  PRIMARY_ADDRESS_FLIPPED:
    "A Primary Address must exist. Please save a primary address before changing the account status to Flipped.",
  BILLING_ADDRESS_FLIPPED:
    "A Billing Address must exist. Please save a billing address before changing the account status to Flipped.",
  NO_CONTACT_ADDRESS_EXISTS:
    "No address exists on this contact. Please select an address before proceeding."
});

export const cssColors = Object.freeze({
  pinkBlue: "color--gradient-pink-blue",
  orangePink: "color--gradient-orange-pink",
  cyanBlue: "color--gradient-cyan-blue",
  bluePurple: "color--gradient-blue-purple",
  greenYellow: "color--gradient-green-yellow",
  blue: "color--blue",
  white: "color--white"
});

export const typeIndexId = Object.freeze({
  YES: 1,
  NO: 0
});

export const schedulesTypeId = Object.freeze({
  DAILY: 1,
  WEEKLY: 2,
  MONTHLY: 3
});

export const splitMovementTypeId = Object.freeze({
  COMPLETED: 120,
  IN_PROGRESS: 121,
  POD_UPLOAD_NEEDED: 122,
  DELETED: 123
});

export const additionalAmountTypes = Object.freeze({
  COST: {
    ID: 1,
    TITLE: "Cost"
  },
  CHARGE: {
    ID: 2,
    TITLE: "Charge"
  }
});

export const additionalAmountReasonTypes = Object.freeze({
  ACCESSORY: 5
});

export const accountContactStatusId = Object.freeze({
  active: 28,
  inactive: 29
});

export const ContactAddressStatusId = Object.freeze({
  Active: 30,
  Inactive: 31
});

export const jobImportStatuses = Object.freeze({
  VALIDATING: "Validating",
  PROCESSING: "Processing",
  ERROR: "Error",
  IMPORTING: "Importing",
  COMPLETE: "Completed",
  PENDING: "Pending"
});

export const accountModuleTypes = Object.freeze({
  PARCELS: 1,
  FULFILL: 2,
  FREIGHT: 3
});

export const payloadTypes = Object.freeze({
  DELETE_ADDITIONAL_AMOUNTS: "DELETE_ADDITIONAL_AMOUNTS"
});

export const timeCheckTypes = Object.freeze({
  FIXED_TIME: {
    ID: 1,
    TEXT: "Fixed Time"
  },
  ASAP: {
    ID: 2,
    TEXT: "ASAP"
  },
  AM: {
    ID: 3,
    TEXT: "AM"
  },
  PM: {
    ID: 4,
    TEXT: "PM"
  },
  TIME_RANGE: {
    ID: 5,
    TEXT: "Time Range"
  },
  ALL_DAY: {
    ID: 6,
    TEXT: "All Day"
  },
  DATE_RANGE: {
    ID: 7,
    TEXT: "Date Range"
  }
});

export const localeTypeId = Object.freeze({
  GB: 1,
  ES: 2,
  US: 3
});

export const supplierOriginSourceTypeId = Object.freeze({
  TMS: 1,
  CX: 2,
  MY_CARRIER: 3,
  FTL_HIGHWAY: 4
});

export const vehicleTypeId = Object.freeze({
  ftl: 43
});

export const vehicleBodyTypeId = Object.freeze({
  na: 12
});

export const serviceTypeId = Object.freeze({
  adr: 1,
  airFreight: 2,
  noSpecialRequirements: 3,
  fullDayRate: 4,
  goodsOnHangar: 5,
  groupageInternational: 6,
  groupageUk: 7,
  halfDayRate: 8,
  international: 9,
  regularPlannedRoutes: 10,
  specialistVehicles: 11,
  temperatureControlled: 12,
  traction: 13,
  twoPerson: 14,
  wasteManagement: 15,
  ftl: 16,
  ltl: 17,
  other: 18
});

export const highwayRulesAssessmentResult = Object.freeze({
  PASS: { value: "pass", colour: "#28a745" },
  PARTIAL_PASS: { value: "partial_pass", colour: "#ffc107" },
  FAIL: { value: "fail", colour: "#dc3545" },
  INCOMPLETE: { value: "incomplete", colour: "#dc3545" }
});

export const highwayConnectionStatus = Object.freeze({
  ONBOARDED: { value: "onboarded", colour: "#28a745" },
  NEEDS_TO_ONBOARD_BUT_CAN_REMAIN_ACTIVE: {
    value: "needs_to_onboard_but_can_remain_active",
    colour: "#ffc107"
  },
  NEEDS_TO_ONBOARD: { value: "needs_to_onboard", colour: "#ffc107" },
  DO_NOT_DISPATCH: { value: "do_not_dispatch", colour: "#dc3545" }
});

export const getHighwayRulesColour = (name) => {
  if (!name) return null;
  const match = Object.values(highwayRulesAssessmentResult).find(
    (entry) => entry.value === name
  );
  return match?.colour ?? null;
};

export const highwayTicketStatus = Object.freeze({
  new: { colour: "#ffc107" },
  open: { colour: "#17a2b8" },
  escalated: { colour: "#dc3545" },
  in_progress: { colour: "#007bff" },
  reopened: { colour: "#fd7e14" }
});

export const getHighwayConnectionStatusColour = (name) => {
  if (!name) return null;
  const match = Object.values(highwayConnectionStatus).find(
    (entry) => entry.value === name
  );
  return match?.colour ?? null;
};

export const blockedStatusTypeId = Object.freeze({
  YES: { booleanInd: 1, value: "Yes", text: "Blocked" },
  NO: { booleanInd: 0, value: "No", text: "Active" }
});

export const defaultLocaleTypes = Object.freeze({
  [localeTypeId.GB]: {
    taxRateId: taxRateTypeId.VAT_20,
    localeId: localeTypeId.GB,
    currencyId: currencyTypeId.POUND,
    currencySymbol: "£"
  },
  [localeTypeId.ES]: {
    taxRateId: taxRateTypeId.VAT_21,
    localeId: localeTypeId.ES,
    currencyId: currencyTypeId.EURO,
    currencySymbol: "€"
  },
  [localeTypeId.US]: {
    taxRateId: taxRateTypeId.VAT_0,
    localeId: localeTypeId.US,
    currencyId: currencyTypeId.DOLLAR,
    currencySymbol: "$"
  }
});

export const defaultItemTypeValues = Object.freeze({
  PALLETS_UK: {
    itemTypeId: 4,
    length: 120,
    width: 100,
    height: 100
  },
  PALLETS_EURO: {
    itemTypeId: 11,
    length: 120,
    width: 80,
    height: 100
  },
  PALLETS_US: {
    itemTypeId: 15,
    length: 120,
    width: 100,
    height: 100
  },
  UNSPECIFIED: {
    itemTypeId: 14,
    length: 1,
    height: 1,
    width: 1
  }
});

export const goodItemTypes = Object.freeze({
  COLLECTION: "collection",
  DELIVERY: "delivery"
});

export const branchTypeId = Object.freeze({
  OWNED: 1,
  FRANCHISEE: 2,
  RTB: 3,
  NONE: 4,
  SUPPORT_CENTRE: 5
});

export const branchStatusId = Object.freeze({
  ACTIVE: 3,
  INACTIVE: 4
});

export const userStatusId = Object.freeze({
  ACTIVE: 5,
  LOCKED: 6,
  EXPIRED: 7,
  DISABLED: 8,
  NOT_ACTIVATED: 9
});

export const datLoadStatus = Object.freeze({
  ALLOCATED: 200,
  ACTIVE: 201,
  EXPIRED: 202,
  DELETED: 21
});

export const userPreferenceTypeId = Object.freeze({
  UOM: { typeId: 1, value: "UOM" },
  INTL_TEL_PREFIX: { typeId: 2, value: "INTL_TEL_PREFIX" }
});

export const statusTypeCategories = Object.freeze({
  accountArea: "account_area",
  job: "job",
  customerInvoice: "customer_invoice"
});

export const boardTypes = Object.freeze({
  trafficBoard: "traffic-board",
  jobBoard: "job-board"
});
